<template>
  <div class="m-container">
    <div class="m-home-container">
      <div class="m-home-head">
        <div class="m-home-top">
          画梦笔总公司数据
          <div @click="toPage('user')" class="m-home-close">
            <i class="el-icon-switch-button"></i>
          </div>
          <div @click="toPage('homeUserData')" class="m-home-data">
            <i class="el-icon-monitor"></i>
          </div>
          <div class="m-imitate-box" @click="imitateShowInput = true">
          </div>
          <div class="m-input-box" v-if="imitateShowInput">
            <el-input v-model="inputImitate.imitateAllMoney" size="mini" placeholder="总金额" style="width: 70px;"></el-input>
            <el-input v-model="inputImitate.imitateDayMoney" size="mini" placeholder="今日金额" style="width: 70px;"></el-input>
            <el-input v-model="inputImitate.imitateAllUser" size="mini" placeholder="总人数" style="width: 70px;"></el-input>
            <el-input v-model="inputImitate.imitateDayUser" size="mini" placeholder="今日人数" style="width: 70px;"></el-input>
            <el-button size="mini" type="primary" @click="openImitate">确定</el-button>
          </div>
          <div class="m-timer-box">
            <div class="m-timer-p">
              <div class="m-timer-progress" :style="'width:'+ (progressNum(timerNum)) +'%'"></div>
            </div>
            <div class="m-timer-text">
              {{ getNowTime(timerNum) }} 刷新
            </div>
            <div style="margin-left: 10px">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link" style="color: #ffffff;">
                  {{ dropText }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="60">1分钟</el-dropdown-item>
                  <el-dropdown-item command="120">2分钟</el-dropdown-item>
                  <el-dropdown-item command="300">5分钟</el-dropdown-item>
                  <el-dropdown-item command="600">10分钟</el-dropdown-item>
                  <el-dropdown-item command="900">15分钟</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="m-home-cont">
<!--    左侧显示位    -->
        <div class="m-home-left">
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="onlineTimeList.length > 0"
              :tipsName="'时长'"
              :dataJson="onlineTimeList"
              :dayList="day7List"
              :tooltip="'判断活跃用户数，配合购买金额、阅读历史判断活跃用户转化收益率'"
              :title="'近七日用户在线时长(分钟)'">
            </curve-date>
          </div>
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="day7LoginNumberList.length > 0"
              :tipsName="'人数'"
              :dataJson="day7LoginNumberList"
              :dayList="day7LoginDay"
              :tooltip="'判断活跃用户数'"
              :title="'近七日用户登录数(人)'">
            </curve-date>
          </div>
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="todayReadHoursList.length > 0"
              :tipsName="'份数'"
              :dataJson="todayReadHoursList"
              :dayList="todayReadHoursDay"
              :tooltip="'判断每天高峰期时间段'"
              :title="'今日每小时在线阅读收听报告份数(份)'">
            </curve-date>
          </div>
        </div>
<!--     中间总数据-->
        <div class="m-home-center">
          <div class="m-home-number">
            <template ref="number1" v-if="imitateHiding && allNumber.allMoney > 0">
              <number-item :num="allNumber.allMoney" :title="'总金额'" :unit="'元'"></number-item>
              <number-item :num="allNumber.dayMoney" :title="'今日金额'" :unit="'元'"></number-item>
              <number-item :num="allNumber.allUser" :title="'总人数'" :unit="'人'"></number-item>
              <number-item :num="allNumber.dayUser" :title="'今日人数'" :unit="'人'"></number-item>
            </template>
            <template ref="number2" v-if="imitateShow">
              <number-item :num="imitateAllMoney" :title="'总金额'" :unit="'元'"></number-item>
              <number-item :num="imitateDayMoney" :title="'今日金额'" :unit="'元'"></number-item>
              <number-item :num="imitateAllUser" :title="'总人数'" :unit="'人'"></number-item>
              <number-item :num="imitateDayUser" :title="'今日人数'" :unit="'人'"></number-item>
            </template>
          </div>
          <div class="m-home-map" v-loading="proviceUserNumLoading">
            <Map v-if="!proviceUserNumLoading" :dataJson="dataList"></Map>
          </div>
<!--     底部折线图     -->
          <div class="m-home-center-bottom">
            <el-scrollbar>
              <div class="regional_table" style="width:780px;height:166px;">
                <el-table :data="bayInfoList" v-loading="bayInfoLoading" style="width: 100%;" size="small" :show-header="false">
                  <el-table-column prop="description" label="购买名称" align="center"></el-table-column>
                  <el-table-column prop="pay_money" label="购买价格" width="110" align="center"></el-table-column>
                  <el-table-column prop="city_county_id" label="用户地区" width="110" align="center"></el-table-column>
                  <el-table-column prop="pay_date" label="支付时间" width="110" align="center"></el-table-column>
                </el-table>
              </div>
            </el-scrollbar>
          </div>
        </div>
<!--     右侧显示位   -->
        <div class="m-home-right">
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="day15MoneyList.length > 0"
              :tipsName="'金额'"
              :dataJson="day15MoneyList"
              :dayList="day15MoneyDay"
              :tooltip="'无人购买则不显示当日，查看收入情况'"
              :title="'近15天每天购买额(元)'">
            </curve-date>
          </div>
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="day15BuyVipList.length > 0"
              :tipsName="'份数'"
              :dataJson="day15BuyVipList"
              :dayList="day15BuyVipDay"
              :tooltip="'无人购买则不显示当日，查看vip购买情况'"
              :title="'近15天每天购买vip数'">
            </curve-date>
          </div>
          <div class="m-home-left-item" style="width: 100%;height: 31.5%;">
            <curve-date
              v-if="day15BuyNoVipList.length > 0"
              :tipsName="'份数'"
              :dataJson="day15BuyNoVipList"
              :dayList="day15BuyNoVipDay"
              :tooltip="'无人购买则不显示当日，查看单报告购买情况'"
              :title="'近15天每天购买单报告数'">
            </curve-date>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumberItem from './Number_item'
import Map from './Map'
import CurveDate from './Curve_date'
import RoundDate from './Round_date'
import Read15Date from './Read_15_date'
export default {
  name: 'Home',
  components: {
    NumberItem,
    Map,
    CurveDate,
    RoundDate,
    Read15Date
  },
  data () {
    return {
      dropText: '5分钟',
      timer: null,
      timerNum: 0,
      timerNumMax: 300,
      imitateShowInput: false,
      imitateHiding: true,
      imitateShow: false,
      bayInfoLoading: false,
      bayInfoList: [],
      // 模拟数据
      dataList: [
        { code: '000003', name: '南海诸岛', value: 0 },
        { code: '110000', name: '北京', value: 80 },
        { code: '120000', name: '天津', value: 0 },
        { code: '310000', name: '上海', value: 0 },
        { code: '500000', name: '重庆', value: 0 },
        { code: '130000', name: '河北', value: 0 },
        { code: '410000', name: '河南', value: 0 },
        { code: '530000', name: '云南', value: 0 },
        { code: '210000', name: '辽宁', value: 0 },
        { code: '230000', name: '黑龙江', value: 0 },
        { code: '430000', name: '湖南', value: 0 },
        { code: '340000', name: '安徽', value: 0 },
        { code: '370000', name: '山东', value: 0 },
        { code: '650000', name: '新疆', value: 4 },
        { code: '320000', name: '江苏', value: 0 },
        { code: '330000', name: '浙江', value: 0 },
        { code: '360000', name: '江西', value: 0 },
        { code: '420000', name: '湖北', value: 0 },
        { code: '450000', name: '广西', value: 0 },
        { code: '620000', name: '甘肃', value: 0 },
        { code: '140000', name: '山西', value: 0 },
        { code: '150000', name: '内蒙古', value: 10000 },
        { code: '610000', name: '陕西', value: 0 },
        { code: '220000', name: '吉林', value: 0 },
        { code: '350000', name: '福建', value: 0 },
        { code: '520000', name: '贵州', value: 0 },
        { code: '440000', name: '广东', value: 0 },
        { code: '630000', name: '青海', value: 0 },
        { code: '540000', name: '西藏', value: 0 },
        { code: '510000', name: '四川', value: 0 },
        { code: '640000', name: '宁夏', value: 0 },
        { code: '460000', name: '海南', value: 0 },
        { code: '000000', name: '台湾', value: 0 },
        { code: '000001', name: '香港', value: 0 },
        { code: '000002', name: '澳门', value: 0 }
      ],
      allNumberLoading: false,
      allNumber: {
        allMoney: 0,
        dayMoney: 0,
        allUser: 0,
        dayUser: 0
      },
      imitateAllMoney: 0,
      imitateDayMoney: 0,
      imitateAllUser: 0,
      imitateDayUser: 0,
      inputImitate: {
        imitateAllMoney: 0,
        imitateDayMoney: 0,
        imitateAllUser: 0,
        imitateDayUser: 0
      },
      // ----
      day7List: [],
      onlineTimeList: [],
      day7Loading: false,
      // ----
      day7LoginDay: [],
      day7LoginNumberList: [],
      day7LoginNumberLoading: false,
      // -----
      todayReadHoursLoading: true,
      todayReadHoursDay: [],
      todayReadHoursList: [],
      // -----
      day15ReadNumLoading: true,
      day15ReadNumDay: [],
      day15ReadNumList: [],
      // -----
      day15MoneyLoading: true,
      day15MoneyDay: [],
      day15MoneyList: [],
      // -----
      day15BuyVipLoading: true,
      day15BuyVipDay: [],
      day15BuyVipList: [],
      // -----
      day15BuyNoVipLoading: true,
      day15BuyNoVipDay: [],
      day15BuyNoVipList: [],
      // -----
      proviceUserNumLoading: true
    }
  },
  methods: {
    // 显示模拟总数据，切换显示加延时，否则切换失效
    openImitate () {
      this.imitateAllMoney = Number(this.inputImitate.imitateAllMoney)
      this.imitateDayMoney = Number(this.inputImitate.imitateDayMoney)
      this.imitateAllUser = Number(this.inputImitate.imitateAllUser)
      this.imitateDayUser = Number(this.inputImitate.imitateDayUser)
      this.imitateShowInput = false
      this.imitateHiding = !this.imitateHiding
      let that = this
      setTimeout(function () {
        that.imitateShow = !that.imitateShow
      }, 0)
    },
    // 下拉倒计时时间选项
    handleCommand (command) {
      this.timerNumMax = parseFloat(command).toFixed(0)
      this.timerNum = this.timerNumMax
      switch (command) {
        case '60':
          this.dropText = '1分钟'
          break
        case '120':
          this.dropText = '2分钟'
          break
        case '300':
          this.dropText = '5分钟'
          break
        case '600':
          this.dropText = '10分钟'
          break
        case '900':
          this.dropText = '15分钟'
          break
      }
    },
    // 退出监控跳转用户信息页
    toPage (path) {
      this.$router.push({name: path})
    },
    // 近7日用户总在线时间
    day7OnlineTime () {
      let _this = this
      this.day7Loading = true
      _this.day7List = []
      _this.onlineTimeList = []
      this.$axios.post('/adminData/day7OnlineTime')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day7List.push(list[i].days + ' 日')
              _this.onlineTimeList.push(list[i].num)
            }
          }
          _this.day7Loading = false
        })
    },
    // 近7日用户登录数
    day7LoginNum () {
      let _this = this
      this.day7LoginNumberLoading = true
      _this.day7LoginDay = []
      _this.day7LoginNumberList = []
      this.$axios.post('/adminData/day7LoginNum')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day7LoginDay.push(list[i].days + ' 日')
              _this.day7LoginNumberList.push(list[i].num)
            }
          }
          _this.day7LoginNumberLoading = false
        })
    },
    // 今日每小时在线阅读收听报告人数
    todayReadHours () {
      let _this = this
      this.todayReadHoursLoading = true
      _this.todayReadHoursDay = []
      _this.todayReadHoursList = []
      this.$axios.post('/adminData/todayReadHours')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.todayReadHoursDay.push(list[i].hours + ' 时')
              _this.todayReadHoursList.push(list[i].num)
            }
          }
          _this.todayReadHoursLoading = false
        })
    },
    // 近15天在线阅读收听报告人数
    day15ReadNum () {
      let _this = this
      this.day15ReadNumLoading = true
      _this.day15ReadNumDay = []
      _this.day15ReadNumList = []
      this.$axios.post('/adminData/day15ReadNum')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day15ReadNumDay.push(list[i].days + ' 日')
              _this.day15ReadNumList.push(list[i].num)
            }
          }
          _this.day15ReadNumLoading = false
        })
    },
    // 近15天每天购买额
    day15MoneyNum () {
      let _this = this
      this.day15MoneyLoading = true
      _this.day15MoneyDay = []
      _this.day15MoneyList = []
      this.$axios.post('/adminData/day15MoneyNum')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day15MoneyDay.push(list[i].days.substring(list[i].days.length - 2) + ' 日')
              _this.day15MoneyList.push(list[i].num / 100)
            }
          }
          _this.day15MoneyLoading = false
        })
    },
    // 近15天每天购买额
    day15BuyVip () {
      let _this = this
      this.day15BuyVipLoading = true
      _this.day15BuyVipDay = []
      _this.day15BuyVipList = []
      this.$axios.post('/adminData/day15BuyVip')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day15BuyVipDay.push(list[i].days + ' 日')
              _this.day15BuyVipList.push(list[i].num)
            }
          }
          _this.day15BuyVipLoading = false
        })
    },
    // 近15天每天购买额
    day15BuyNoVip () {
      let _this = this
      this.day15BuyNoVipLoading = true
      _this.day15BuyNoVipDay = []
      _this.day15BuyNoVipList = []
      this.$axios.post('/adminData/day15BuyNoVip')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < list.length; i++) {
              _this.day15BuyNoVipDay.push(list[i].days + ' 日')
              _this.day15BuyNoVipList.push(list[i].num)
            }
          }
          _this.day15BuyNoVipLoading = false
        })
    },
    // 地图各省级用户量
    proviceUserNum () {
      let _this = this
      this.proviceUserNumLoading = true
      this.$axios.post('/adminData/proviceUserNum')
        .then((res) => {
          if (res.data !== null && res.data.length > 0) {
            let list = res.data
            for (let i = 0; i < _this.dataList.length; i++) {
              for (let a = 0; a < list.length; a++) {
                if (_this.dataList[i].code === list[a].proviceId) {
                  _this.dataList[i].value = list[a].num
                }
              }
            }
          }
          _this.proviceUserNumLoading = false
        })
    },
    // 主页总数据
    loadHomeNumber () {
      let _this = this
      this.$axios.post('/adminData/allNumber')
        .then((res) => {
          if (res.status === 200) {
            _this.allNumber.allMoney = res.data.allMoney / 100
            _this.allNumber.dayMoney = res.data.dayMoney / 100
            _this.allNumber.allUser = res.data.allUser
            _this.allNumber.dayUser = res.data.dayUser
          }
        })
    },
    // 用户购买信息
    loadUserBayInfo () {
      let _this = this
      this.bayInfoLoading = true
      this.$axios.post('/adminData/loadUserBayInfo')
        .then((res) => {
          if (res.status === 200) {
            _this.bayInfoList = res.data
            this.bayInfoLoading = false
          }
        })
    },
    // 秒转换分钟格式
    getNowTime (s) {
      // 计算时分秒数
      let min = parseInt(s / 60 % 60)
      let sec = parseInt(s % 60)
      // 个位数前补零
      min = min > 9 ? min : '0' + min
      sec = sec > 9 ? sec : '0' + sec
      return `${min} : ${sec}`
    },
    // 进度条宽度百分比
    progressNum (s) {
      let aa = s / this.timerNumMax * 100
      return parseFloat((100 - aa).toString()).toFixed(2)
    },
    loadAllApi () {
      this.day15ReadNum()
      this.day7OnlineTime()
      this.day7LoginNum()
      this.todayReadHours()
      this.day15MoneyNum()
      this.day15BuyVip()
      this.day15BuyNoVip()
      this.proviceUserNum()
      this.loadHomeNumber()
      this.loadUserBayInfo()
      // 每隔5分钟定时刷新
      this.timerNum = this.timerNumMax
    }
  },
  mounted () {
    this.loadAllApi()
    this.timer = setInterval(() => {
      this.timerNum--
      if (this.timerNum <= 0) {
        this.loadAllApi()
      }
    }, 1000)
  },
  // 销毁时取消定时器
  beforeDestroy () {
    clearInterval(this.timer) // 清除定时器
    this.timer = null
  }
}
</script>

<style scoped src="../../assets/css/home.css"></style>



// WEBPACK FOOTER //
// src/components/home/Home.vue